<template>
  <div v-if="$store.getters.loading"></div>
  <div v-else>
    <template>
      <template v-if="items.length > 0">
        <v-data-table :headers="headers" :items="items" :pagination.sync="pagination"
          @update:pagination="onPaginationChange" :rows-per-page-items="[5, 10, 20]"
          :total-items="pagination.totalItems" class="elevation-1">
          <template v-slot:items="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.contractType }}</td>
            <td>{{ props.item.statusDisplay }}</td>
            <td>{{ props.item.startDate }}</td>
            <td>{{ props.item.endDate }}</td>
            <td>{{ props.item.club }}</td>
          </template>
        </v-data-table>
      </template>
      <template v-if="contratosCombinados.length > 0">
        <v-data-table :headers="headers" :items="contratosCombinados" :pagination.sync="pagination"
          @update:pagination="onPaginationChange" :rows-per-page-items="[5, 10, 20]"
          :total-items="pagination.totalItems" class="elevation-1">
          <template v-slot:items="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.contractType }}</td>
            <td>{{ props.item.statusDisplay }}</td>
            <td>{{ props.item.startDate }}</td>
            <td>{{ props.item.endDate }}</td>
            <td>{{ props.item.club }}</td>
            <td>{{ props.item.jugador }}</td>
          </template>
        </v-data-table>
      </template>
    </template>
  </div>
</template>

<script>

export default {

  props: {
    personal: {},
    club: {},
    contratosCombinados: {
      type: Array,
      default: () => []
    },
    pantallaFinal: {
      type: Boolean,
      default: () => false
    }
  },

  data () {
    return {
      path: `PlayerAllContracts`,
      page_size: 10,
      page: 1,
      qSearch: '',
      filterPath: 'filters/players',
      search: '', // lo que escribís en el input
      items: [], // acá se guardan los datos de la búsqueda
      searchText: 'Buscar jugador',
      selectedPlayer: null, // aquí guardamos el jugador seleccionado
      pagination: {
        sortBy: 'id',
        descending: false,
        page: 1,
        rowsPerPage: 100,
        totalItems: 0
      }
    }
  },

  computed: {
    headers () {
      let arrayHeaders = [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'Tipo', value: 'contractType', sortable: false },
        { text: 'Contrato', value: 'statusDisplay', sortable: false },
        { text: 'Fecha de inicio', value: 'startDate', sortable: false },
        { text: 'Fecha de fin', value: 'endDate', sortable: false },
        { text: 'Club', value: 'club', sortable: false }
      ]
      if (this.pantallaFinal) {
        arrayHeaders.push({ text: 'Contratos jugador', value: 'jugador', sortable: false })
      }
      return arrayHeaders
    }
    /* properties() {
      let properties = ['player.lastName', 'player.firstName', 'status']
      if (this.$store.getters.isSafRole) {
        properties.splice(3, 0, 'club.nombre')
      }
      return properties
    } */
  },

  methods: {
    handlePlayerSelected (player) {
      this.selectedPlayer = player
      this.buscarContrato()
    },
    setItems (responseData) {
      this.items = responseData.results
    },
    onPaginationChange (newPagination) {
      this.pagination.page = newPagination.page

      // Disparamos la búsqueda de la nueva página
      this.buscarContrato()
    },
    async buscarContrato () {
      this.selectedPlayer = null
      this.loading = true

      /* const params = {
        q: this.search
      } */
      try {
        const response = await this.axios.get(`PlayerAllContracts/${this.personal.pk}`)
        this.items = response.data
        this.$emit('update:items', response.data)
        this.loading = false
      } catch (error) {
        /* this.loading = false
        let validError = error?.response?.data?.detail
        if (validError && error.response.data.detail.includes('Página inválida')) {
          this.pagination.page = 1
        } else {
          this.$store.commit('setErrorMsg', error)
        } */
      }
    }
  },
  watch: {
    personal: {
      handler (newVal) {
        if (newVal && newVal.pk) {
          if (!this.pantallaFinal) {
            this.buscarContrato()
          }
        }
      },
      deep: true,
      immediate: true
    },
    contratosCombinados: {
      handler (newVal) {
      },
      deep: true, // 🔑 escucha cambios internos
      immediate: true // 🔑 dispara al montar el componente
    }
  }
}
</script>
